/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ValidateKeyProject = {
  /**
   * The ID of the project
   */
  id: string;
  /**
   * The name of the project
   */
  name: string;
  /**
   * The slug of the project
   */
  slug: string;
};

/** @internal */
export const ValidateKeyProject$inboundSchema: z.ZodMiniType<
  ValidateKeyProject,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
});

export function validateKeyProjectFromJSON(
  jsonString: string,
): SafeParseResult<ValidateKeyProject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ValidateKeyProject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ValidateKeyProject' from JSON`,
  );
}
